"use client";
//#region packages/@mantine/core/src/components/Anchor/Anchor.module.css
var Anchor_module_default = { "root": "m_849cf0da" };
//#endregion
export { Anchor_module_default as default };

//# sourceMappingURL=Anchor.module.mjs.map